import React,{ useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const RecentPost = () => {
   const location = useLocation();
	const [dropdown, setDropdown] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

	useEffect(() => {
    const storedData = localStorage.getItem("dropdown");

    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        setDropdown(parsedData);
        console.warn("Parsed Data:", parsedData);
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
        setDropdown([]);
      }
    }
  }, []);

	return (
		<>
		<ul className="recentpost">
                    {dropdown.length > 0 ? (
                      dropdown.map((item, index) => (
                        <li key={index} className={`dropactive ${location.pathname === `/${item.route}` ? "active" : ""}`}><Link to={`/${item.route}`} className={location.pathname === `/${item.route}` ? "active" : ""}>{item.name}</Link></li>
                      ))
                    ) : (
                      <li>No data Found</li>
                    )}
        </ul>
        </>
    	);
 };

 export default RecentPost;